var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add a GL Code"},on:{"on-hide":_vm.resetFormData}},[_c('gl-code-form',{key:_vm.formKey,attrs:{"organization":_vm.organization,"organization_id":_vm.organization_id},on:{"on-submit":_vm.createGlCode,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }